import { selectIn } from 'common/util/selector'

const base = (state, props) => state.main.devices.attributes

export const attributeType = selectIn(base, 'attribute_type')
